module.exports = __webpack_public_path__ + "img/icon-task-center.104c4656.svg";